import { useGetMe } from '@/lib/api/me.ts';
import CreateInvestmentPage from './CreateInvestmentPage.tsx';
import CreatePsiInvestmentPage from './CreatePsiInvestmentPage.tsx';

const CreateInvestmentRoute = () => {
  const { data: user } = useGetMe();

  if (!user) {
    return <div>Cargando...</div>;
  }

  if (user.role === 'psi') {
    return <CreatePsiInvestmentPage />;
  }

  return <CreateInvestmentPage />;
};

export default CreateInvestmentRoute;
